// Oracle's rule for /mfa/password/reset (Sanil, 2026-10-27): 10–128 characters, at least one letter and one digit,
// and not the user's email or username. Oracle is the judge (422 WEAK_PASSWORD); this only shows the rule up front.
export const PASSWORD_MIN = 10;
export const PASSWORD_MAX = 128;

export const passwordRules = (password = "", email = "") => {
  const value = String(password);
  const ownEmail = String(email || "").trim().toLowerCase();
  return [
    { id: "length", label: "10 to 128 characters", ok: value.length >= PASSWORD_MIN && value.length <= PASSWORD_MAX },
    { id: "letter", label: "At least one letter", ok: /[A-Za-z]/.test(value) },
    { id: "digit", label: "At least one number", ok: /[0-9]/.test(value) },
    // Only when the email is known: a ✓ that checked nothing would mislead. Oracle enforces it either way.
    ...(ownEmail ? [{ id: "notEmail", label: "Not your email address", ok: value.trim().toLowerCase() !== ownEmail }] : []),
  ];
};

export const passwordReady = (password, confirm, email) =>
  passwordRules(password, email).every((rule) => rule.ok) && password === confirm;
